<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4">
        <div v-html="message"></div>
        <br />
        <v-row>
          <v-col cols="12" class="my-0 py-1">
            <p class="my-0 py-0">
              <span class=" ">
                Para confirmar introdusca <span class="font-weight-bold red--text">"{{ valid_text }}"</span>
              </span>
            </p>
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            <v-text-field outlined v-model="text_input" dense hide-details />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn v-if="text_input === valid_text" color="primary darken-1" text @click.native="agree">Aceptar</v-btn>
        <v-btn color="grey" text @click.native="cancel">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component, only have three options {color, width, zIndex}
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yesv-dialog
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm
 * }
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: 'mensaje',
    title: 'titulo',
    valid_text: 'aprobar',
    text_input: null,
    options: {
      color: 'primary',
      width: 320,
      zIndex: 200,
    },
  }),
  methods: {
    open(title, message, valid_text, options) {
      this.dialog = true;
      this.valid_text = valid_text;
      this.title = title ? title : this.title;
      this.message = message ? message : this.message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.text_input = null;
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>